// extracted by mini-css-extract-plugin
export default {"filter":"tableAccessories_filter__VmiRR","empty":"tableAccessories_empty__IBuzN"};